import { Component, ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error('ErrorBoundary caught:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }
      
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Authentication Error</h2>
          <p>Please refresh the page or clear your browser cache.</p>
          <button 
            onClick={() => {
              localStorage.clear()
              sessionStorage.clear()
              window.location.href = '/login'
            }}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              cursor: 'pointer',
              background: '#667eea',
              color: 'white',
              border: 'none',
              borderRadius: '4px'
            }}
          >
            Clear Storage & Retry
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
